/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/LEVELS
 *
 * @description
 * ## Simple wrapper to hold all the level data
 * - Sets the order in which levels are played
 */


import { BASIC } from "./LEVEL_DATA/BASIC.js";
import { DENSE } from "./LEVEL_DATA/DENSE.js";
import { INTRO } from "./LEVEL_DATA/INTRO.js";
import { JUNGL } from "./LEVEL_DATA/JUNGL.js";
import { MAUVE } from "./LEVEL_DATA/MAUVE.js";
import { MERNG } from "./LEVEL_DATA/MERNG.js";
import { MULT1 } from "./LEVEL_DATA/MULT1.js";
import { MULT2 } from "./LEVEL_DATA/MULT2.js";
import { MUSTD } from "./LEVEL_DATA/MUSTD.js";
import { RRRED } from "./LEVEL_DATA/RRRED.js";
import { REDDD } from "./LEVEL_DATA/REDDD.js";
import { TOOEZ } from "./LEVEL_DATA/TOOEZ.js";
import { GARDN } from "./LEVEL_DATA/GARDN.js";
import { GNSMK } from "./LEVEL_DATA/GNSMK.js";
import { STRRY } from "./LEVEL_DATA/STRRY.js";
import { PEKMN } from "./LEVEL_DATA/PEKMN.js";
import { SWARM } from "./LEVEL_DATA/SWARM.js";
import { WISTA } from "./LEVEL_DATA/WISTA.js";
import { ALIEN } from "./LEVEL_DATA/ALIEN.js";
import { CHPLN } from "./LEVEL_DATA/CHPLN.js";
import { OPRTN } from "./LEVEL_DATA/OPRTN.js";
import { NTPOR } from "./LEVEL_DATA/NTPOR.js";
import { LMOLV } from "./LEVEL_DATA/LMOLV.js";
import { BLRDS } from "./LEVEL_DATA/BLRDS.js";

export const LEVEL_DATA = {
  INTRO: INTRO,
  BASIC: BASIC,
  TOOEZ: TOOEZ,
  MERNG: MERNG,
  LMOLV: LMOLV,
  MAUVE: MAUVE,
  JUNGL: JUNGL,
  RRRED: RRRED,
  MUSTD: MUSTD,
  BLRDS: BLRDS,
  MULT1: MULT1,
  MULT2: MULT2,
  DENSE: DENSE,
  REDDD: REDDD,
  GARDN: GARDN,
  GNSMK: GNSMK,
  STRRY: STRRY,
  PEKMN: PEKMN,
  SWARM: SWARM,
  WISTA: WISTA,
  ALIEN: ALIEN,
  CHPLN: CHPLN,
  OPRTN: OPRTN,
  NTPOR: NTPOR,
};
